export const FAVORITES_KEY = 'vayu_dl_favorites';

//  Auth info from localized script (injected from PHP)
export const isUserLoggedIn = window?.vayuBlocksUser?.isLoggedIn || false;
export const userId = window?.vayuBlocksUser?.id || null;

//  Utility to ensure uniqueness
const uniqueArray = (arr) => [...new Set(arr.filter(Boolean))];

//  Save to localStorage (Guest users)
export const saveFavoritesToLocal = (favorites) => {
	try {
		const deduped = uniqueArray(favorites);
		localStorage.setItem(FAVORITES_KEY, JSON.stringify(deduped));
	} catch {}
};


//  Get from localStorage (Guest users)
export const getFavoritesFromLocal = () => {
	try {
		const raw = localStorage.getItem(FAVORITES_KEY);
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? uniqueArray(parsed) : [];
	} catch {
		return [];
	}
};


//  Save to server (Logged-in users)
export const saveFavoritesToUser = async (favorites) => {
	if (!isUserLoggedIn) return;

	try {
		await fetch(`/wp-json/vayu-blocks/v1/user-favorites`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': window?.wpApiSettings?.nonce || '',
			},
			credentials: 'include',
			body: JSON.stringify({ favorites: uniqueArray(favorites) }),
		});
	} catch (err) {
		console.error('Failed to save user favorites:', err);
	}
};

//  Unified getter for favorites (Guest or Logged-in)
export const getFavorites = async () => {
	const local = getFavoritesFromLocal();

	if (isUserLoggedIn) {
		try {
			const res = await fetch(`/wp-json/vayu-blocks/v1/user-favorites`, {
				method: 'GET',
				headers: {
					'X-WP-Nonce': window?.wpApiSettings?.nonce || '', //  Nonce for auth
				},
				credentials: 'include',
			});
			const json = await res.json();

			const serverFavs = Array.isArray(json.favorites) ? json.favorites : [];
			const merged = [...serverFavs, ...local];
			const deduped = uniqueArray(merged);

			return deduped;
		} catch (err) {
			console.warn('Failed to load server favorites. Falling back to local.', err);
			return local;
		}
	}

	return local;
};

//  Toggle favorite (adds/removes, then saves to correct store)
export const toggleFavorite = async (id) => {
	let favorites = await getFavorites();

	if (favorites.includes(id)) {
		favorites = favorites.filter((fav) => fav !== id);
	} else {
		favorites.push(id);
	}

	favorites = uniqueArray(favorites);

	if (isUserLoggedIn) {
		await saveFavoritesToUser(favorites);
	} else {
		saveFavoritesToLocal(favorites);
	}

	return favorites;
};

//  Helper: Check if item is in favorite list
export const isFavorite = (id, favorites = []) => {
	return favorites.includes(id);
};
